import { Pipe, PipeTransform } from '@angular/core';
import { KeyValuePipe } from '@angular/common';

@Pipe({
    name: 'controlfilter',
    pure: false
})
export class ControlFilterPipe implements PipeTransform {
    transform(items: any[], filter: any, properties: any): any {
        if (!items || !filter) {
            return items;
        }
        if (!properties) {
            var temp = items.filter(item => item.Text.toLowerCase().indexOf(filter.toLowerCase()) !== -1);
            return temp;
        }
        else {
            var temp = items.filter(item => properties[item.key].Text.toLowerCase().indexOf(filter.toLowerCase()) !== -1)
            return temp;
        }
    }
}